import styled from 'styled-components';

const StatsPageContainer = styled.div`
    padding-top: var(--section-padding);
    padding-bottom: var(--section-padding);
    text-align: center;
    background-image: url('https://i.ibb.co/ZfMktD1/stats.png');
    background-size: cover;
    position: relative;
    &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background-color: rgb(0 0 0 / 70%);
    }
    .container {
        position: relative;
        display: flex;
        flex-wrap: wrap;
    }
`;

export default StatsPageContainer;
